import { Modal, Container } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import Table from "../../Components/TableTemplate/BreakdownTable";
import { getProjectSalesReport } from "../../Helpers/apiCalls/SalesReport/SalesReportApi";

//css
import "./Modal.css";
import { formatDateNoTime, numberFormat } from "../../Helpers/Utils/Common";

function SalesBreakdownModal(props) {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.show && props.data.length > 0) {
      fetchProjectSales(props.data[0]);
    }
  }, [props.show, props.data]);

  async function fetchProjectSales(payload) {
    setLoading(true);
    try {
      const response = await getProjectSalesReport(payload);

      let rows = [];
      if (response.data && response.data.data) {
        let data = response.data.data;
        // backend search has no company filter, so narrow to the clicked company here
        if (payload.company) {
          data = data.filter(
            (item) => item.project_invoice?.[0]?.company === payload.company
          );
        }
        rows = data.map((item) => {
          const invoice = item.project_invoice?.[0];
          return {
            invoice_no: invoice?.invoice_no || "N/A",
            project_invoice_id: invoice?.id,
            deposit_date: item.deposit_date ? formatDateNoTime(item.deposit_date) : "",
            customer_name: item.customer_name || "N/A",
            remarks: item.remarks || "",
            amount: numberFormat(item.paid_amount),
          };
        });

        // latest first — same ordering as the Monthly Sales report
        rows.sort((a, b) => new Date(b.deposit_date) - new Date(a.deposit_date));
      }

      setTableData(rows);
    } catch (error) {
      setTableData([]);
    }
    setLoading(false);
  }

  // first column = clickable invoice link (mirrors ExpensesBreakdownModal's ViewButton)
  function ViewButton(row) {
    return (
      <div className="mx-3">
        <a
          href={`/projectinvoice/process/${row.project_invoice_id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="table-button me-3 p-2 d-inline-block text-decoration-none text-center"
        >
          {row.invoice_no}
        </a>
      </div>
    );
  }

  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        className="modal-cont-receivables"
        size={props.size}
        centered
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="col-sm-12 col-6">
            <div className="col-sm-12">
              <span className="custom-modal-body-title">
                Sales Breakdown
                {props.data.length > 0 && props.data[0].account_type_name && (
                  <span className="text-muted ms-2">- {props.data[0].account_type_name}</span>
                )}
              </span>
            </div>
            <Container fluid className="modal-cont receivableAgingContainer">
              <div className="sales-tbl receivableAging" style={{ overflowX: "auto" }}>
                <Table
                  tableHeaders={["INVOICE NO", "DEPOSIT DATE", "CUSTOMER", "DESCRIPTION", "PAID AMT"]}
                  headerSelector={[
                    "invoice_no",
                    "deposit_date",
                    "customer_name",
                    "remarks",
                    "amount",
                  ]}
                  tableData={tableData}
                  ViewButton={(row) => ViewButton(row)}
                  fixedHeader
                  fixedHeaderScrollHeight="40vh"
                  showLoader={loading}
                  withActionData={false}
                  className={{
                    customers: "text-text-start text-break ps-2 align-top",
                  }}
                />
              </div>
            </Container>

            <div className="col-sm-12 mt-3 d-flex justify-content-end">
              <button className="button-tertiary mr-3" onClick={props.onHide}>
                Close
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

SalesBreakdownModal.defaultProps = {
  title: "",
  type: "",
  size: "xl",
  show: () => {},
  onHide: () => {},
};

export default SalesBreakdownModal;